import { useAuth } from '@xhubio-saas/core-frontend/kernel'
import type { ReactNode } from 'react'
import { trpc } from '@/trpc'
import {
  type EntitlementRestriction,
  EntitlementRestrictionContext,
} from './EntitlementRestrictionContext'

/**
 * Fetches billing entitlements from the backend and provides them
 * to the EntitlementRestrictionContext.
 *
 * This enables usePermissions() to combine RBAC + billing checks.
 */
export function BillingEntitlementProvider({ children }: { children: ReactNode }) {
  const { session } = useAuth()
  const { data, isLoading } = trpc.billing.getBillingEntitlements.useQuery(undefined, {
    enabled: !!session?.user,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  })

  const value: EntitlementRestriction = {
    billingEntitlements: data?.entitlements ?? null,
    isLoading,
  }

  return (
    <EntitlementRestrictionContext.Provider value={value}>
      {children}
    </EntitlementRestrictionContext.Provider>
  )
}
